import React, { useState } from "react";
import "../../../styles/legacy/MobileForgotPassword.css";
import { requestResetPassword } from "shared/api/client/orvalHelpers";

interface MobileForgotPasswordProps {
  onClose: () => void;
  setErrorMessage: (message: string) => void;
  setMessageBanner: (message: string) => void;
}

const MobileForgotPassword: React.FC<MobileForgotPasswordProps> = ({
  onClose,
  setErrorMessage,
  setMessageBanner,
}) => {
  const [email, setEmail] = useState("");

  const handleResetPassword = async () => {
    try {
      await requestResetPassword(email);
      const successMessage = "Reset link sent successfully.";
      onClose();
      setMessageBanner(successMessage);
      setTimeout(() => {
        setMessageBanner("");
      }, 5000);
    } catch (err) {
      console.error("Reset password error:", err);
      onClose();
      setErrorMessage("An error occurred. Please try again.");
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    }
  };

  return (
    <div className="mobile-forgot-password-modal">
      <img className="logo" src="/images/poetics-stream-lockup.svg" alt="Poetics Stream logo" />
      <div className="top-message-mobile">
        <div className="title-login-mobile">Reset password</div>
        <div className="subtitle-login-mobile">
          A reset password link will be sent to your email address
        </div>
      </div>
      <div className="email-container-reset-mobile">
        <span className="reset-email-label">Email</span>
        <input
          type="email"
          placeholder="Enter your email address"
          className="reset-input-field-mobile"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="button-container-reset-mobile">
        <button
          className="buttons-reset-mobile"
          id="cancel-btn-reset-mobile"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="buttons-reset-mobile"
          id="reset-btn-reset-mobile"
          onClick={handleResetPassword}
        >
          Reset password
        </button>
      </div>
    </div>
  );
};

export default MobileForgotPassword;
